var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',_vm._b({staticClass:"has-cursor-help",attrs:{"type":"is-dark","label":_vm.$t('_sentence.delegates.delegated_object_tooltip', {
      objectType: _vm.objectType.toLowerCase()
    })}},'b-tooltip',_vm.$attrs,false),[_c('b-icon',{attrs:{"icon":"id-card-alt","size":"is-small","type":"is-info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }